import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import api from "../lib/api";
import PageRenderer from "../components/common/PageRenderer";
import PageHero from "./PageHero";
import Seo from "../components/common/Seo";
import { useI18n } from "../lib/i18n";

/** Dynamic public page — renders any CMS page by slug. */
const DynamicPage = () => {
  const { slug } = useParams();
  const { pick } = useI18n();
  const [page, setPage] = useState(null);
  const [status, setStatus] = useState("loading");

  useEffect(() => {
    setStatus("loading");
    api.get(`/public/pages/${slug}`)
      .then((r) => { setPage(r.data); setStatus("ok"); })
      .catch(() => setStatus("notfound"));
  }, [slug]);

  if (status === "loading") return <div className="container-x pt-40 pb-20">…</div>;
  if (status === "notfound") return (
    <div className="container-x pt-40 pb-40 text-center">
      <div className="display display-md">404</div>
      <p className="mt-4 text-brand-medium">Sayfa bulunamadı.</p>
    </div>
  );

  const hasBlocks = (page?.blocks || []).length > 0;

  return (
    <div data-testid="dynamic-page">
      <Seo seo={page?.seo} fallbackTitle={pick(page?.title)} fallbackDescription={pick(page?.excerpt)} fallbackImage={page?.hero_image} />
      {hasBlocks ? <PageRenderer blocks={page.blocks} /> : (
        <>
          <PageHero title={page.title} subtitle={page.excerpt} image={page.hero_image} />
          {pick(page?.content) ? (
            <section className="bg-white">
              <div className="container-x py-20 md:py-28 max-w-3xl">
                <div className="text-brand-dark text-lg leading-relaxed whitespace-pre-line">{pick(page.content)}</div>
              </div>
            </section>
          ) : null}
        </>
      )}
    </div>
  );
};

export default DynamicPage;
